import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TLanguage {
  code: string;
  name: string;
  id: number;
}

export interface ILanguage extends TLanguage {}

const Language = Model((model: TLanguage): ILanguage => {
  const _language: TLanguage = Object.assign({}, model);

  let create = (language: ILanguage): ILanguage => {
    let obj = ValidatableObject(language);
    return obj;
  };

  let language = {
    get code() {
      return _language.code;
    },
    set code(value) {
      _language.code = value;
    },
    get name() {
      return _language.name;
    },
    set name(value) {
      _language.name = value;
    },
    get id() {
      return _language.id;
    },
    set id(value) {
      _language.id = value;
    }
  };

  return create(language);
});

export default Language;
